import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  SubTitle,
  UnderlineText,
  Text,
  LeftSide,
  Column,
  Row,
  InputContainer,
  Inputs,
  Icon,
  ButtonContainer,
  StyledInput,
} from './SignupPage.styles';
import Button from '../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../assets/icons/logoBlack.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Step1Page from './Steps/SignupStep1Page';
import Step3Page from './Steps/SignupStep3Page';
import MainContainer from '../../../components/MainContainer/MainContainer';
import { useDispatch, useSelector } from 'react-redux';
import { postVendorInfo } from '../../../store/slice/vendor/asyncThunks';
import { notifyError, notifyInfo } from '../../../utils/notify';
import Step2Page from './Steps/SignupStep2Page';
import { selectVerifyEmailPending, setEmailInput, setPasswordInput } from '../../../store/slice/auth/slice';
import { verifyEmail } from '../../../store/slice/auth/asyncThunks';
import { toast } from 'react-toastify';
import { blobUrlToFile, isValidPassword } from '../../../utils/utils';
import { selectOnboardingInfo } from '../../../store/slice/onboarding/slice';

const SignupPage = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const onboardingInfo = useSelector(selectOnboardingInfo);

  let [searchParams] = useSearchParams();
  const tabParam = searchParams.get('step');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  // const [isPasswordValid, setIsPasswordValid] = useState(false);
  // const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);
  const [visibility, setVisibility] = useState(true);
  const [visibility2, setVisibility2] = useState(true);
  const loading = useSelector(selectVerifyEmailPending);
  const passwordsMatch = password === confirmPassword;
  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // const validatePassword = password => {
  //   return password.length >= 8;
  // };

  const handleEmailChange = e => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsEmailValid(validateEmail(newEmail));
  };

  const handlePasswordChange = e => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    // setIsPasswordValid(validatePassword(newPassword));
  };

  const handleConfirmPasswordChange = e => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    // setIsConfirmPasswordValid(validatePassword(newConfirmPassword));
  };

  const buttonDisable = !isEmailValid || !passwordsMatch || loading;

  const handleVisibilityChange = () => {
    setVisibility(!visibility);
  };

  const handleVisibilityChange2 = () => {
    setVisibility2(!visibility2);
  };

  const handleContinueClick = obj => {
    navigation({
      pathname: '/sign-up',
      search: `?step=${obj.tab}`,
    });
  };

  const setPlaceIdAndContinue = placeId => {
    navigation({
      pathname: '/sign-up',
      search: `?step=3`,
    });
  };

  const handleSignUp = async () => {
    let filesArray = [];
    for (const img of onboardingInfo.images) {
      const file = await blobUrlToFile(img, 'vendorPhoto.jpg');
      filesArray.push(file);
    }
    const fileBanner = await blobUrlToFile(onboardingInfo.banner, 'bannerPhoto.jpg');
    notifyInfo(
      'Uploading media, this may take a few minutes depending on the speed of your connection, please wait...',
    );
    dispatch(
      postVendorInfo({
        images: filesArray,
        banner: fileBanner,
        name: onboardingInfo.name,
        address: onboardingInfo.address,
        showAddress: onboardingInfo.showAddress,
        vendorCategoryId: onboardingInfo.vendorCategory.id,
        instagram: onboardingInfo.instagram,
        facebook: onboardingInfo.facebook,
        twitter: onboardingInfo.twitter,
        tiktok: onboardingInfo.tiktok,
        links: onboardingInfo.links,
        phoneNumber: onboardingInfo.phoneNumber.value,
        googlePlaceId: onboardingInfo.googlePlaceId,
        websiteLink: onboardingInfo.websiteLink,
        emailToShow: onboardingInfo.emailToShow,
      }),
    )
      .unwrap()
      .then(() => {
        // navigation("/clients");
      })
      .catch(err => notifyError(err.message));
  };

  const goToVerification = () => {
    if (isValidPassword(password)) {
      dispatch(verifyEmail(email))
        .unwrap()
        .then(() => {
          dispatch(setPasswordInput(password));
          dispatch(setEmailInput(email));
          navigation('/verification-code');
        })
        .catch(err => toast.error(err.message));
    } else {
      toast.error(
        'Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase. Special Characters are #?!@$%^&*-',
      );
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      if (+tabParam === 0) {
        goToVerification();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keypress', handleKeyPress);

    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <MainContainer>
      {+tabParam === 0 && (
        <LeftSide>
          <Logo width={110} height={58} />

          <Column>
            <Title>Welcome!</Title>
            <SubTitle>Create an account.</SubTitle>
          </Column>
          <InputContainer>
            <Inputs>
              <StyledInput placeholder="Email Address" value={email} onChange={handleEmailChange} />
              <StyledInput
                placeholder="Password"
                value={password}
                type={visibility ? 'password' : 'text'}
                rightIcon={
                  visibility ? (
                    <Icon onClick={handleVisibilityChange}>🙈</Icon>
                  ) : (
                    <Icon onClick={handleVisibilityChange}>🐵</Icon>
                  )
                }
                onChange={handlePasswordChange}
              />
              <StyledInput
                rightIcon={
                  visibility2 ? (
                    <Icon onClick={handleVisibilityChange2}>🙈</Icon>
                  ) : (
                    <Icon onClick={handleVisibilityChange2}>🐵</Icon>
                  )
                }
                placeholder="Confirm Password"
                type={visibility2 ? 'password' : 'text'}
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
            </Inputs>
          </InputContainer>
          <ButtonContainer>
            <Button disabled={buttonDisable} title={'Continue'} onClick={goToVerification} width loading={loading} />
            <Row>
              <Text>Already have an account?</Text>
              <UnderlineText onClick={() => navigation('/')}>Login</UnderlineText>
            </Row>
          </ButtonContainer>
        </LeftSide>
      )}

      {+tabParam === 1 && <Step1Page onContinueClick={handleContinueClick} />}
      {+tabParam === 2 && <Step2Page onContinueClick={setPlaceIdAndContinue} />}
      {+tabParam === 3 && <Step3Page handleSignUp={handleSignUp} />}
    </MainContainer>
  );
};

export default SignupPage;
